/**
 * The scrambler behind the break screen's end-of-schedule filler.
 *
 * When the schedule runs out, each empty row renders `> GIOCATORE n PREMI START <` as
 * four `.fizzle` spans; this flickers random ones through junk characters so the rows do
 * not sit there dead. The Portal easter egg drives the same spans, which is why these
 * helpers live on their own — they are the one thing break-schedule-renderer and
 * still-alive.js share, and putting them here keeps those two from importing each other.
 *
 * No imports on purpose. Keep it that way.
 */
export const fizzle = {
    /** Spans currently showing junk, so two timers cannot scramble the same one. */
    fizzling: [],

    fizzleWatcherInterval: undefined,
    getFizzle(row, index) {
        return document.querySelector('#break-next .fizzle-' + index + '.row-' + row);
    },

    fizzleTimer: (level, interval) => {
        const fizzleIntervalN = setInterval(function () { fizzle.fizzleOneRandom(level); }, interval);
        setTimeout(function () {
            clearInterval(fizzleIntervalN);
        }, fizzle.getRandomNumber(100 * level, 400 * level));
    },

    getFizzleable() {
        return document.querySelectorAll('#break-next .fizzle');
    },

    fizzleOneRandom: (level) => {
        let words = ["SOGG", "IORNO"];

        const fizzleable = fizzle.getFizzleable();
        const toFizzle = fizzleable[fizzle.getRandomNumber(0, fizzleable.length)];
        const word = words[fizzle.getRandomNumber(0, words.length)];
        fizzle.fizzleOneWithWord(toFizzle, word, level);

    },

    fizzleOneWithWord(toFizzle, word, level) {
        if (fizzle.fizzling.includes(toFizzle)) return;

        fizzle.fizzling.push(toFizzle);
        const oldContents = toFizzle.innerHTML;
        toFizzle.innerHTML = word;
        const timeoutDuration = fizzle.getRandomNumber(600 * level, 900 * level);
        setTimeout(function () {
            toFizzle.innerHTML = oldContents;
            var index = fizzle.fizzling.indexOf(toFizzle);
            if (index !== -1) {
                fizzle.fizzling.splice(index, 1);
            }
        }, timeoutDuration);
    },

    getRandomNumber(min, max) {
        return parseInt(Math.random() * (max - min) + min);
    },

};

window.fizzle = fizzle;
